<!--
 * @Description: In User Settings Edit
 * @Author: your name
 * @Date: 2019-08-26 18:15:08
 * @LastEditTime: 2021-01-20 11:30:44
 * @LastEditors: daikeyi
 -->
<template>
<div id="page_Container">
    <div class="page">
        <div id='main-container' class="main-container">
            <div class='addressList' v-if='addressListShow'>
                <div class='list' v-for='item in addressList' :key='item.id'>
                    <div class='listTop'>
                        <p>
                            <strong>{{item.receiver}}</strong>
                            <strong>{{item.mobileNumber}}</strong>
                        </p>
                        <p>
                            {{item.area}} {{item.address}}
                        </p>
                    </div>
                    <div class='listBottom'>
                        <van-checkbox v-model="item.defaultFlag" class='isaddress' @change='changeDefaultCheck(item)'></van-checkbox>
                        <!-- <van-radio v-model="item.defaultFlag" class='isaddress' @click='changeDefaultCheck(item)'></van-radio> -->
                        <span class='defaultAddressSpan'>默认地址</span>
                        <div class='operation'>
                            <p class='p1' @click='editAdd(item)'>
                                <van-icon name="edit-data" class='pIcon' />
                                <span>编辑</span>
                            </p>
                            <p @click='deleteAdd(item)'>
                                <van-icon name="delete" class='pIcon' />
                                <span>删除</span>
                            </p>
                        </div>
                    </div>
                </div>
            </div>
            <div v-if='!addressListShow' class='addressShowBox'>
                <img :src="noListUrl" alt="">
                <p>暂时没有地址,去新增一个吧！</p>
            </div>
            <div class='btnStyle'>
                <van-button round type="danger" @click='creatAddress'>+ 新建</van-button>
            </div>
        </div>
        <van-popup v-model="show" position="right" :overlay="false" class='creatRight'>
            <div class='creatAddress'>
                <van-cell-group>
                    <van-field required v-model="Consignee" label="收货人：" placeholder="请输入收货人" :error-message="consigneeError" @focus='focusInput' />
                    <van-field required v-model="mobileNumber" label="联系电话：" placeholder="请输入联系电话" :error-message="phoneError" @focus='focusInput' />
                </van-cell-group>
                <van-cell-group class='mt12'>
                    <van-cell required title="所在地区：" is-link :value="addressValue" @click='chooseAddress' />
                    <van-field required v-model="DetailedAddress" label="详细地址：" :maxlength='50' type="textarea" placeholder="请输入详细地址" @focus='focusInput' rows="1" autosize :error-message="addressError" />
                    <van-cell title='设为默认地址' label="注：每次下单将默认该地址为收货地址">
                        <van-switch v-model="checked" />
                    </van-cell>
                </van-cell-group>
            </div>
            <div class='btnStyle'>
                <van-button round type="danger" @click='saveAddress' :loading='saveLoading' v-if='isEditShow'>添加</van-button>
                <van-button round type="danger" @click='updateSaveAddress' v-if='!isEditShow'>保存</van-button>
                <van-button round @click='cancel' :disabled='cancelButton' class='cancelBtn'>取消</van-button>
            </div>
        </van-popup>
        <van-popup v-model="addressShow" position="bottom" :overlay="false">
            <van-area :area-list="areaList" value="110101" @cancel='cancelArea' @confirm='confirmArea' />
        </van-popup>
    </div>
</div>
</template>

<script>
import {
    Toast,
    Dialog
} from 'vant';
import {
    toastLoading,
    clearToastLoading,
    confirmModal
} from '@/utils/base/utils';
export default {
    components: {
        Toast,
        Dialog
    },
    data() {
        return {
            checked: true,
            show: false,
            addressShow: false,
            Consignee: '',
            mobileNumber: '',
            DetailedAddress: '',
            areaList: {},
            addressValue: '',
            areaId: '',
            leftUrl: require('../assets/img/myCenter/leftclick.png'),
            noListUrl: require('../assets/img/myCenter/noList.png'),
            addressList: [],
            consigneeError: '',
            phoneError: '',
            addressError: '',
            saveLoading: false,
            addressListShow: true,
            echoData: {},
            isEditShow: true,
            id: '',
            cancelButton: false
        };
    },
    esvReady() {
        const ths = this;
        document.title = '地址管理';
        this.queryAddressSS();
        this.queryAddress();
        window.addEventListener(
            'popstate',
            function (e) {
                if (ths.show) {
                    ths.show = false;
                    ths.$router.go(-1);
                }
            },
            false
        );
    },
    esvShow() {},
    methods: {
        queryAddress() {
            const ths = this;
            ths.$doRequest({
                url: '/address/queryMemberShippingAddressList',
                params: {

                },
                before: function () {
                    ths.loading = toastLoading();
                },
                complete: function () {
                    clearToastLoading(ths.loading);
                }
            },
            function (data) {
                if (data.responseCode === '100000') {
                    ths.addressList = data.result;
                    ths.addressList.forEach(function (element) {
                        if (element.defaultFlag === 2) {
                            element.defaultFlag = false;
                        } else {
                            element.defaultFlag = true;
                        }
                    });
                }
                if (ths.addressList.length > 0) {
                    ths.addressListShow = true;
                } else {
                    ths.addressListShow = false;
                }
            }
            );
        },
        queryAddressSS() {
            const ths = this;
            ths.$doRequest({
                url: '/region/queryCommonRegionList',
                params: {

                },
                complete: function () {}
            },
            function (data) {
                ths.areaList = data.result;
            }
            );
        },
        creatAddress() {
            if (this.addressList.length >= 5) {
                Dialog.alert({
                    title: '',
                    message: '最多设置5个地址'
                }).then(() => {});
                return false;
            }
            this.show = true;
            this.isEditShow = true;
            this.Consignee = '';
            this.mobileNumber = '';
            this.addressValue = '';
            this.areaId = '';
            this.DetailedAddress = '';
            this.checked = true;
        },
        saveAddress() {
            const ths = this;
            if (ths.Consignee.length <= 0) {
                ths.consigneeError = '收货人不能为空';
                return false;
            }
            if (ths.mobileNumber.length <= 0) {
                ths.phoneError = '联系电话不能为空';
                return false;
            }
            if (!/^0[0-9]{2,3}-[0-9]{7,8}$/.test(ths.mobileNumber) && !/^1[3456789][0-9]{9}$/.test(ths.mobileNumber)) {
                ths.phoneError = '请输入合法的号码';
                return false;
            }
            if (ths.addressValue.length <= 0) {
                Toast('所在地区不能为空');
                return false;
            }
            if (ths.DetailedAddress.length <= 0) {
                ths.addressError = '详细地址不能为空';
                return false;
            }
            ths.saveLoading = true;
            const params = {
                mobileNumber: ths.mobileNumber,
                receiver: ths.Consignee,
                area: ths.addressValue,
                areaId: ths.areaId,
                address: ths.DetailedAddress,
                defaultFlag: ths.checked === true ? 1 : 2
            };
            ths.$doRequest({
                url: '/address/saveMemberShippingAddress',
                params: params,
                before: function () {
                    ths.loading = toastLoading();
                },
                complete: function () {
                    clearToastLoading(ths.loading);
                    ths.saveLoading = false;
                }
            },
            function (data) {
                if (data.responseCode === '100000') {
                    ths.queryAddress();
                    ths.show = false;
                }
            }
            );
        },
        updateSaveAddress() {
            const ths = this;
            if (ths.Consignee.length <= 0) {
                ths.consigneeError = '收货人不能为空';
                return false;
            }
            if (ths.mobileNumber.length <= 0) {
                ths.phoneError = '联系电话不能为空';
                return false;
            }
            if (!/^0[0-9]{2,3}-[0-9]{7,8}$/.test(ths.mobileNumber) && !/^1[3456789][0-9]{9}$/.test(ths.mobileNumber)) {
                ths.phoneError = '请输入合法的号码';
                return false;
            }
            if (ths.addressValue.length <= 0) {
                Toast('所在地区不能为空');
                return false;
            }
            if (ths.DetailedAddress.length <= 0) {
                ths.addressError = '详细地址不能为空';
                return false;
            }
            const params = {
                id: ths.id,
                receiver: ths.Consignee,
                mobileNumber: ths.mobileNumber,
                area: ths.addressValue,
                areaId: ths.areaId,
                address: ths.DetailedAddress,
                defaultFlag: ths.checked === 1 || ths.checked === true ? 1 : 2
            };
            ths.$doRequest({
                url: '/address/updateMemberShippingAddress',
                params: params,
                before: function () {
                    ths.loading = toastLoading();
                },
                complete: function () {
                    clearToastLoading(ths.loading);
                }
            },
            function (data) {
                if (data.responseCode === '100000') {
                    ths.queryAddress();
                    ths.show = false;
                }
            }
            );
        },
        focusInput() {
            const ths = this;
            ths.addressShow = false;
            ths.consigneeError = '';
            ths.phoneError = '';
            ths.addressError = '';
        },
        // 删除地址
        deleteAdd(item) {
            const ths = this;
            confirmModal('确定要删除该地址吗？', function () {
                const params = {
                    id: item.id
                };
                ths.$doRequest({
                    url: '/address/deleteMemberShippingAddress',
                    params: params,
                    before: function () {
                        ths.loading = toastLoading();
                    },
                    complete: function () {
                        clearToastLoading(ths.loading);
                    }
                },
                function (data) {
                    if (data.responseCode === '100000') {
                        ths.queryAddress();
                    }
                }
                );
            });
        },
        changeDefaultCheck(item) {
            this.updateAddress(item);
        },
        updateAddress(item) {
            const ths = this;
            const params = {
                id: item.id,
                mobileNumber: item.mobileNumber,
                receiver: item.receiver,
                area: item.area,
                areaId: ths.areaId,
                address: item.address,
                defaultFlag: item.defaultFlag === true ? 1 : 2
            };
            // debugger;
            ths.$doRequest({
                url: '/address/updateMemberShippingAddress',
                params: params,
                before: function () {
                    ths.loading = toastLoading();
                },
                complete: function () {
                    clearToastLoading(ths.loading);
                }
            },
            function (data) {
                if (data.responseCode === '100000') {
                    ths.queryAddress();
                }
            }
            );
        },
        editAdd(item) {
            const ths = this;
            ths.show = true;
            ths.isEditShow = false;
            ths.Consignee = item.receiver;
            ths.mobileNumber = item.mobileNumber;
            ths.addressValue = item.area;
            ths.DetailedAddress = item.address;
            ths.checked = item.defaultFlag;
            ths.id = item.id;
        },
        cancel() {
            this.show = false;
        },
        chooseAddress() {
            this.addressShow = true;
            this.cancelButton = true;
        },
        cancelArea() {
            this.addressShow = false;
            this.cancelButton = false;
        },
        confirmArea(data) {
            let value = '';
            let id = '';
            data.forEach(function (val, index) {
                value += val.name + '-';
                id += val.code + ',';
            });
            value = value.substring(0, value.length - 1);
            id = id.substring(0, id.length - 1);
            this.addressValue = value;
            this.areaId = id;
            this.addressShow = false;
            this.cancelButton = false;
        }
    },
    esvBack(backFn) {
        console.log(this.isEditShow);
        if (this.show) {
            this.show = false;
            backFn && backFn(false);
        } else {
            backFn && backFn(true);
        }
    }
};
</script>

<style lang="scss" scoped>
.addressList {
    .list:nth-child(1) {
        margin-top: 5px;
    }

    .list {
        padding: 12px;
        background: #fff;
        color: #666;
        font-size: 14px;
        margin-top: 12px;

        p {
            padding: 5px 0;
        }

        .listBottom {
            padding: 10px 0 0 0;
            line-height: 22px;
            overflow: hidden;
            color: #999;

            .isaddress {
                float: left;
                margin-top: 3px;
            }

            .operation {
                float: right;

                .p1 {
                    margin-right: 5px;
                }

                p {
                    display: inline-block;
                    padding: 0;
                    margin-top: 3px;

                    .pIcon {
                        float: left;
                        margin: 3px 4px 0 0;
                    }
                }
            }
        }

        .listTop {
            padding-bottom: 5px;
            border-bottom: 1px solid #e3e2e2;
        }
    }
}

.btnStyle {
    text-align: center;
    margin: 25px 0;

    .van-button {
        width: 80%;
    }

    .van-button--danger {
        background: #ee2e50;
        border: 1px solid #ee2e50;
    }
}

.creatRight {
    width: 100%;
    height: 100%;
    background: #f2f2f2;
}

.backStyle {
    padding: 4px 15px;
    border: none;
    background: #fff;
}

.mt12 {
    margin-top: 12px;
}

.btnStyle {
    text-align: center;

    .van-button {
        width: 80%;
    }

    .van-button--danger {
        background: #ee2e50;
        border: 1px solid #ee2e50;
    }
}

.defaultAddressSpan {
    margin: 3px 0 0 5px;
    float: left;
}

.addressShowBox {
    text-align: center;
    margin-top: 50px;

    img {
        width: 203px;
    }
}

.cancelBtn {
    margin-top: 15px;
}
</style>
